import { ItemTypeConsts } from 'client/util/Constants';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';
import LocalStorageConsts from 'client/util/Constants/LocalStorageConstants';

const DevicesSettingsMainPanel = () => import('client/systems/DevicesSettingsMainPanel.vue');
const DevicesTabsMainPanel = () => import('client/systems/DevicesTabsMainPanel.vue');
const SystemAsidePanel = () => import('client/systems/SystemAsidePanel.vue');

const devicesProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.device,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.device,
    isAsideOpen: false,
    itemType: ItemTypeConsts.device,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Devices',
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.device].learnMoreUrl,
    pText: GettingStartedPanelSettings[ItemTypeConsts.device].tooltipText,
  },
};

export default [
  // Adding a redirect for backwards compatibility of any reference to /devices in the admin portal.
  {
    path: '/devices',
    beforeEnter: (to, from, next) => {
      const devicesMainPanelLocalStorage = JSON.parse(
        localStorage.getItem(
          LocalStorageConsts.devicesMainPanelLandingTab,
        ),
      ) || {};

      if (devicesMainPanelLocalStorage.deviceListHomePage) {
        next({ path: '/devices/list' });
      } else {
        next({ path: '/devices/overview' });
      }
    },
  },
  {
    path: '/devices/overview',
    name: 'devicesMainPanel',
    meta: metaData,
    components: {
      mainPanel: DevicesTabsMainPanel,
    },
    props: {
      mainPanel: {
        ...devicesProps.mainPanel,
        initialTabIndex: 0,
      },
    },
  },
  {
    path: '/devices/list',
    name: 'devicesList',
    meta: metaData,
    components: {
      mainPanel: DevicesTabsMainPanel,
    },
    props: {
      mainPanel: {
        ...devicesProps.mainPanel,
        initialTabIndex: 1,
      },
    },
  },
  {
    path: '/devices/new/:os?',
    name: 'newDevice',
    meta: metaData,
    components: {
      mainPanel: DevicesTabsMainPanel,
      asidePanel: SystemAsidePanel,
    },
    props: {
      mainPanel: {
        ...devicesProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...devicesProps.asidePanel,
        os: route.params.os,
      }),
    },
  },
  {
    path: '/devices/:id/details',
    name: 'devicesDetails',
    meta: metaData,
    components: {
      mainPanel: DevicesTabsMainPanel,
      asidePanel: SystemAsidePanel,
    },
    props: {
      mainPanel: {
        ...devicesProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...devicesProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/devices/:id/details/:initialTab',
    name: 'devicesDetailsInitialTab',
    meta: metaData,
    components: {
      mainPanel: DevicesTabsMainPanel,
      asidePanel: SystemAsidePanel,
    },
    props: {
      mainPanel: {
        ...devicesProps.mainPanel,
        initialTabIndex: 1,
      },
      asidePanel: route => ({
        ...devicesProps.asidePanel,
        itemId: route.params.id,
        navigateToTab: { tabLabel: route.params.initialTab },
      }),
    },
  },
  {
    path: '/devices/settings',
    name: 'devicesSettings',
    meta: metaData,
    components: {
      mainPanel: DevicesSettingsMainPanel,
    },
  },
];
